
import {defineComponent} from 'vue';

export default defineComponent({
  props: {
    value: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split(''),
  }),
});
